import _ from 'lodash';

import {serializeToPlainText} from '../../editor/Serializer';

const getFirstPage = (file) => {
    var firstPage = _.find(file.nodes, function(o) { 
        return o.nodeClazz === "PageFirstNode"; 
    })
    return firstPage;
}

const getNodeById = (file, id) => {
    var nodes = _.find(file.nodes, {id})
    return nodes;
}

const getNodeLink = (file, nodeId, from = true) => {
    var link = _.find(file.links, function(o) { 
        if(from)
            return o.fromNode === nodeId; 
        else 
            return o.toNode === nodeId;
    });
    return link;
}

const getNodeLinks = (file, nodeId, from = true, sortByFromPort=false) => {
    var links = _.filter(file.links, function(o) { 
        if(from)
            return o.fromNode === nodeId; 
        else 
            return o.toNode === nodeId;
    });
    if(sortByFromPort) {
        links.sort((a,b) => 
            (a.fromPort > b.fromPort) ? 1 : -1
        )
    }
    return links;
}

const recurseTree = (file, currentEnding, currentNodeId, endings, allNodes, seenLinks = new Set(), nodeDepthMap = [], currentNodeDepth=0) => {
    const currentNode = getNodeById(file, currentNodeId);
    var links = getNodeLinks(file, currentNodeId, false, true);

    if(currentNode.type === "PAGE") {
        seenLinks.add(currentNode.id)
        allNodes.add(currentNode.id)
        currentNodeDepth++;
        if(!nodeDepthMap[currentNodeId] || currentNodeDepth > nodeDepthMap[currentNodeId])
            nodeDepthMap[currentNodeId] = currentNodeDepth;
    } else if (currentNode.nodeClazz === "ModifierRandomNode") {
        endings[currentEnding].hasRandom = true;
    }

    // check if current node is beginning page
    if ( currentNode.nodeClazz === "CheckUniversalNode" || currentNode.nodeClazz === "PageFirstNode") {
        endings[currentEnding]={
            maxNodeDepth: currentNodeDepth,
            hasRandom: endings[currentEnding].hasRandom || false,
            isUniversalCheck: (currentNode.nodeClazz === "CheckUniversalNode")
        }
    } else {
        for (var i = 0; i < links.length; i++) {
            if(!seenLinks.has(links[i].fromNode) && (currentNodeDepth + 1) > (nodeDepthMap[links[i].fromNode] || 0)) { 
                recurseTree(file, currentEnding, links[i].fromNode, endings, allNodes, new Set(seenLinks), nodeDepthMap, currentNodeDepth);
            }
        }
    }

    return endings;
}

const getEndingStats = (file) => {
    var endings = {};

    // Working from endings up to beginning page
    const nodes = _.filter(file.nodes, (o) => {
        return (o.type==="PAGE" && getNodeLinks(file, o.id, true, true).length === 0)
    })

    for(let node of nodes) {
        var allNodes = new Set();
        endings[node.id] = {}
        recurseTree(file, node.id, node.id, endings, allNodes);
        // Ending is found and attached to first page / check universal
        if(endings[node.id].maxNodeDepth) {
            var wordCount = 0;
            allNodes.forEach((node)=>{
                var currentNode = getNodeById(file, node);
                if(Array.isArray(currentNode.description)) {
                    wordCount += serializeToPlainText(currentNode.description).replace(/ +/g, " ").split(" ").length;
                }
                if(currentNode?.configuration?.routes) {
                    currentNode.configuration.routes.forEach(choice=>{
                        wordCount += serializeToPlainText(choice.content).replace(/ +/g, " ").split(" ").length;
                    })
                }
            })
            endings[node.id].wordCount = Math.round(wordCount / allNodes.size * endings[node.id].maxNodeDepth)
        } else {
            delete endings[node.id]
        }
    }

    return endings;
}

const getAchievementCount = (file) => {
    return Object.keys(file?.achievements ? file.achievements : {})?.length
}

export {
    getFirstPage,
    getNodeById,
    getNodeLink,
    getNodeLinks,
    getEndingStats,
    getAchievementCount,
}